import styled from 'styled-components';
import { ReactNode } from 'react';

export const ImageContainer = styled.div<{
  className?: string;
  children?: ReactNode;
}>`
  img {
    border-radius: 10px;
    @media (min-width: 768px) {
      border-radius: 16px;
    }
  }
`;

export const IconWrapper = styled.div`
  height: 1em;
  width: 1em;
  margin-right: 0.5em;
`;
